// extracted by mini-css-extract-plugin
module.exports = {"card":"faqs_card__3SRHA","ques":"faqs_ques__2cgVx","active":"faqs_active__IkOZi","ans":"faqs_ans__6W88S"};